var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-bar'),_c('navigation-drawer'),_c('v-main',{staticStyle:{"margin":"0 1rem"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }